import { IPlannedOrder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { PlannedOrderWorkItem } from 'src/app/business/plannedOrder/planned-order-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class PlannedOrderCommandHandler extends EntityCommandHandler<IPlannedOrder> {
  protected workItem: IWorkItem<IPlannedOrder>;

  constructor(plannedOrderWorkItem: PlannedOrderWorkItem) {
    super();
    this.workItem = plannedOrderWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'PlannedOrderDto';
  }
}
